<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: ['data', 'options', 'max'],
  data () {
    return {
      defaultOptions: {
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: this.max || 100
              }
            }
          ]
        }
      }
    }
  },
  mounted () {
    this.renderChart(this.data, this.options || this.defaultOptions)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/share/BarChart.vue